import { Grid } from "@mui/material";
import useStyles from "../styles";
import { useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Button from "../../../components/Button/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Modal from "../../../components/Modal";

const PersonalInformation = () => {
  const classes = useStyles();

  const [file, setFile] = useState();
  const [offboardModal, setOffboardModal] = useState(false);

  const handleOffBoardModal = () => {
    setOffboardModal(!offboardModal);
  };

  const handleCloseOffBoard = () => {
    setOffboardModal(false);
  };

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Personal Information</h4>
            <h6>Update your personal details here</h6>
            <div className={classes.profilecontainer}>
              <div className={classes.imageviewer}>
                <div className={classes.pickercontainer}>
                  <input type="file" name="profile_picture" value={file} className={classes.profilepicker} onChange={handleChange} />
                  <CameraAltIcon className={classes.camera} />
                </div>
              </div>
            </div>
            <Button variant="primaryoutline" color="btnfontprimary" buttonSize="full" buttonName="off board employees" onClick={handleOffBoardModal} />
          </div>

        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container">
            <Grid container spacing={2} className={classes.profileform}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="First Name" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Last Name" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Email Address" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Gender" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Phone Number" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Role" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={6} xs={12}>
                <InputGroup inputType="text" label="Reporting to" name="" />
              </Grid>
            </Grid>
            <div className={classes.btnspace}>
              <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" />
            </div>
          </div>

        </Grid>
      </Grid>
      <Modal
        title="Off board employee"
        subtitle="Are you sure you want to off board Eugene Adavore. If leave off boarded, employee will no longer have access to this platform."
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Off board Employee" buttonSize="full" color="btndefault" />
          </>
        }
        isopen={offboardModal}
        closeModal={handleCloseOffBoard}
      />
    </>
  );
};

export default PersonalInformation;
